import React from 'react';
// import Header from 'components/commercetools-ui/header';
import ECommerceNavbar from 'components/tailgrids-ui/navbar';
import { calculateCartCount } from 'helpers/utils/calculateCartCount';
import { useCart, useWishlist, useAccount } from 'frontastic/provider';

const HeaderTastic = ({ data, previewId }) => {
  const { data: cart } = useCart();
  const { data: wishlist } = useWishlist();
  const { account } = useAccount();

  return (
    <ECommerceNavbar
      banner={{
        enabled: data?.banner_enabled,
        text: data?.banner_text,
        bgColor: data?.banner_bg_color,
        color: data?.banner_color,
      }}
      links={data.links}
      cartItemCount={calculateCartCount(cart?.lineItems) || 0}
      wishlistItemCount={wishlist?.lineItems?.length || 0}
      logo={data.logo}
      logoLink={data.logoLink}
      account={account}
      accountLink={data.accountLink}
      wishlistLink={data.wishlistLink}
      cartLink={data.cartLink}
      previewId={previewId}
      categoryHierarchy={data.categories.dataSource}
    />
  );
};

export default HeaderTastic;
